import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys } from './helper'
import { httpGet, httpPost } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from '../ducks/app'
import r from 'reactotron-react-js'

const COC_GET_LIST = makeKeys('COC_COC_GET_LIST')
const COC_GET_STATUS = makeKeys('COC_GET_STATUS')
const COC_GET_DETAIL = makeKeys('COC_GET_DETAIL')
const COC_SUBMIT_FORM = makeKeys('COC_SUBMIT_FORM')
const GET_VENDOR_EMAIL = makeKeys('GET_VENDOR_EMAIL')
const COC_CREATE = makeKeys('COC_CREATE')

export const getListCOC = makeAction(COC_GET_LIST.REQUEST, 'search')
export const getCOCSummary = makeAction(COC_GET_STATUS.REQUEST)
export const getCOCDetail = makeAction(COC_GET_DETAIL.REQUEST, 'id')
export const submitCOC = makeAction(COC_SUBMIT_FORM.REQUEST, 'data', 'onSuccess')
export const getVendorEmail = makeAction(GET_VENDOR_EMAIL.REQUEST, 'vendorCode')
export const createCodeOfConduct = makeAction(COC_CREATE.REQUEST, 'vendorCode', 'onSuccess')

const getListCOCSuccess = makeAction(COC_GET_LIST.SUCCESS, 'data')
const getCOCSummarySuccess = makeAction(COC_GET_STATUS.SUCCESS, 'data')
const getCOCDetailSuccess = makeAction(COC_GET_DETAIL.SUCCESS, 'data')
const submitCOCSuccess = makeAction(COC_SUBMIT_FORM.SUCCESS, 'data', 'history')
const getVendorEmailSuccess = makeAction(GET_VENDOR_EMAIL.SUCCESS, 'data')

const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* getListCOCRequest(action) {
  const { search } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(`codeOfConduct`, search)
    yield put(appLoaded())
    if (response.status === 200) {
      yield put(getListCOCSuccess(response.data))
    }
  } catch (error) {
    yield put(appLoaded())
    yield put(toastError(error.data.message))
  }
}

function* getCOCSummaryRequest() {
  try {
    yield put(appLoading())
    const response = yield httpGet(`codeOfConduct/summaryStatus`)
    yield put(appLoaded())
    if (response.status === 200) {
      yield put(getCOCSummarySuccess(response.data))
    }
  } catch (error) {
    yield put(appLoaded())
  }
}

function* getCOCDetailRequest(action) {
  const { id } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(`codeOfConduct/${id}`)
    yield put(appLoaded())
    if (response.status === 200) {
      yield put(getCOCDetailSuccess(response.data))
    }
  } catch (error) {
    yield put(appLoaded())
  }
}

function* submitCOCRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(`codeOfConduct/${data.docId}/action`, data, multipartHeader)
    yield put(appLoaded())
    if (response.status === 200) {
      yield put(submitCOCSuccess(response.data))
      onSuccess()
    }
  } catch (error) {
    yield put(appLoaded())
  }
}

function* getVendorEmailRequest(action) {
  const { vendorCode } = action.payload
  try {
    const response = yield httpGet(`vendors/${vendorCode}/status`)
    if (response.status === 200) {
      yield put(getVendorEmailSuccess(response.data))
    }
  } catch (error) {
    yield put(appLoaded())
  }
}

function* createCodeOfConductRequest(action) {
  const { vendorCode, onSuccess } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(`codeOfConduct/migrate`, { vendorCode })
    yield put(appLoaded())
    if (response.status === 200) {
      onSuccess()
      yield put(toastSuccess(`Create code of conduct for vendor ${vendorCode} success.`))
    }
  } catch (error) {
    r.log({ error })
    if (error && error.data && error.data.message) {
      yield put(toastError(error.data.message))
    } else if (error && error.status ) {
      yield put(toastError(error.statusText))
    } else {
      put(toastError(`Create code of conduct for vendor ${vendorCode} error!`))
    }
    
    yield put(appLoaded())
  }
}

export function* watchCodeOfConductSaga() {
  yield takeLatest(COC_GET_LIST.REQUEST, getListCOCRequest)
  yield takeLatest(COC_GET_STATUS.REQUEST, getCOCSummaryRequest)
  yield takeLatest(COC_GET_DETAIL.REQUEST, getCOCDetailRequest)
  yield takeLatest(COC_SUBMIT_FORM.REQUEST, submitCOCRequest)
  yield takeLatest(GET_VENDOR_EMAIL.REQUEST, getVendorEmailRequest)
  yield takeLatest(COC_CREATE.REQUEST, createCodeOfConductRequest)
}

const initial = {
  listCOC: { data: [], loading: false },
  detailCOC: { data: {}, loading: false },
  summaryCOC: { data: [], loading: false },
  submitCOC: { data: [], loading: false },
  vendorStatus: { data: {}, loading: false },
}

export default createReducer(initial, state => ({
  [COC_GET_LIST.REQUEST]: () => ({ // get list code of conduct
    ...state,
    listCOC: { data: [], loading: true }
  }),
  [COC_GET_LIST.SUCCESS]: (data) => ({ // get success code of conduct
    ...state,
    listCOC: { data: data.data, loading: false }
  }),
  [COC_GET_STATUS.REQUEST]: () => ({ // get summary status code of conduct
    ...state,
    summaryCOC: { data: [], loading: true }
  }),
  [COC_GET_STATUS.SUCCESS]: (data) => ({ // get summary status success code of conduct
    ...state,
    summaryCOC: { data: data.data, loading: false }
  }),
  [COC_GET_DETAIL.REQUEST]: () => ({ // get detail code of conduct
    ...state,
    detailCOC: { data: {}, loading: true }
  }),
  [COC_GET_DETAIL.SUCCESS]: (data) => ({ // get detail success code of conduct
    ...state,
    detailCOC: { data: data.data, loading: false }
  }),
  [COC_SUBMIT_FORM.REQUEST]: () => ({ // submit data code of conduct
    ...state,
    submitCOC: { data: {}, loading: true }
  }),
  [COC_SUBMIT_FORM.SUCCESS]: (data) => ({ // submit data success code of conduct
    ...state,
    submitCOC: { data: data.data, loading: false }
  }),
  [GET_VENDOR_EMAIL.REQUEST]: () => ({ // get vendor status for view email
    ...state,
    vendorStatus: { data: {}, loading: true }
  }),
  [GET_VENDOR_EMAIL.SUCCESS]: (data) => ({ // get success vendor status for view email
    ...state,
    vendorStatus: {...data.data}
  }),
}))